const moment = require('moment');

export const fromNowFilterMixin = {
  filters: {
    fromNow (date) {
      return moment(date).fromNow();
    },
  },
};
